import React, { useContext, useEffect } from 'react';
import { useQuery, QueryClient, QueryClientProvider } from 'react-query';
import { MenuAttributeProps, MenuAttributeTypes } from '../../modal/MenuAttribute';
import FormModal from '../../modal/FormModal';
import { UserSessionDetails, UserSessionDetailsContext } from '../../App';

const queryClient = new QueryClient()

interface ClientAddModalProps {
    refreshTable: () => void;
    isOpen: boolean;
    closeModal: () => void;
    redirectTo: (location: string) => void;
}

const ClientAddModal = (props: ClientAddModalProps): JSX.Element => (
    <QueryClientProvider client={queryClient}>
        <ClientAddModalInner {...props}/>
    </QueryClientProvider>
)

const ClientAddModalInner = (props: ClientAddModalProps): JSX.Element => {
    const sessionDetails: UserSessionDetails = useContext(UserSessionDetailsContext);
    const [nameValue, setNameValue] = React.useState("");
    
    const menuAttributes: MenuAttributeProps[] = [
        {
            name: "Name",
            attributeType: MenuAttributeTypes.short_input,
            set_value: nameValue,
            setValue: setNameValue
        }
    ];

    // disabled if there exists a form element w/ length 0
    const isSaveButtonDisabled = (): boolean =>
        [nameValue].find((el: string) => el.length === 0) !== undefined;
    
    // submit request stuff
    const { data, status, refetch, remove } = useQuery('client_add', async () => {
        const res = await fetch(`${sessionDetails.backend.host}:${sessionDetails.backend.port}/client`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                access_token: sessionDetails.access_token,
                req: {name: nameValue}
            })
        });
        return res.json();
    }, { // options are here so it won't auto-fetch
        refetchOnWindowFocus: false,
        enabled: false
    });
    const loading = status !== 'success' || data.STATUS !== 'SUCCESS';

    const onSubmit = () => {
        refetch();
    }

    useEffect(() => {
        if (!loading) {
            setNameValue('');
            remove();
            props.closeModal();
            props.refreshTable();
            props.redirectTo(`/client_contacts/${data.DATA.id}`);
        }
    }, [loading, props, remove]);
    
    return (
        <FormModal 
            title='Add Client'
            form_strategy='Add'
            menuAttributes={menuAttributes}
            onClose={props.closeModal}
            isOpen={props.isOpen}
            isSaveButtonDisabled={isSaveButtonDisabled}
            onSave={onSubmit}
        />
    );
};

interface ClientResponse {
    DATA: {
        id: number;
        name: string;
    };
}

export default ClientAddModal;